class DisclosureService {
    constructor(_, $http, initConfigProvider, securityService, Upload) {
        this._ = _;
        this.http = $http;
        this.apiPath = initConfigProvider.apiBaseUrl + initConfigProvider.disclosureServiceEndPoint;
        this.securityService = securityService;
        this.callApi = (routePart, httpMethod, acceptCode, data) => {

            return httpMethod(`${this.apiPath}/${routePart}`, data).then((response) => {
                if (this._.find(acceptCode, (ac) => ac === response.status)) {
                    return {
                        data: response.data,
                        error: ''
                    };
                } else if (response.data && response.data.modelState && response.data.modelState.status) {
                    return {
                        data: null,
                        error: response.data.modelState.status
                    };
                } 
                return {
                    data: null,
                    error: 'Disclosure service error'
                };
            }).catch((error) => {
                console.log(error);
                return {
                    data: null,
                    error: 'Disclosure service error'
                };
            });
        };
        this.upload = Upload;
    }

    getDisclosure(disclosureid) {
        let routePart = `${disclosureid}`;
        return this.callApi(routePart, this.http.get, [200], null);
    }

    getPagedDisclosures(filter) {
        let curtinId = this.securityService.getAutheticatedUserId();

        let routePart = `?curtinId=${curtinId}&pageSize=${filter.pageSize || 20}&pageIndex=${filter.pageIndex || 1}&statusList=${filter.statusList || ""}&sortColumn=${filter.sortColumn || ""}&sortDirection=${filter.sortDirection || "Descending"}&Download=false`;

        return this.callApi(routePart, this.http.get, [200], null);
    }

    getAlternativeOfficer(disclosureId) {
        let routePart = `${disclosureId}/alternativeOfficer`;
        return this.callApi(routePart, this.http.get, [200, 204], null);
    }

    getFile(fileDto) {
        return this.http.get(`${this.apiPath}/${fileDto.disclosureId}/attachments/${fileDto.fileId}`, { responseType: 'blob' }).then((response) => {
            if (response.status === 200) {
                return {
                    data: new Blob([response.data], { type: response.headers()['content-type'] }),
                    error: '',
                    isMessageFile: response.data.type === "application/vnd.ms-outlook" ? true : false
                };
            } else if (response.status === 204) {
                return {
                    data: null,
                    error: ''
                }
            } else {
                if (response.data && response.data.error) {
                    return {
                        data: null,
                        error: response.data.error,
                        isValidFile: false
                    };
                }
            }
            return {
                data: null,
                error: 'Download disclosure file service error'
            };
        }).catch((error) => {         
            return {
                data: null,
                error: 'Download disclosure file service error'
            };
        });
    }

    deleteFile(disclosureId, fileId) {
        let routePart = `${disclosureId}/attachments/${fileId}`;
        return this.callApi(routePart, this.http.delete, [204], null);
    }

    saveDisclosure(data) {
        let patchReq = data.id && data.id !== 0;
        let httpMethod = patchReq ? this.http.patch : this.http.post;
        let routePart = patchReq ? `${data.id}` : '';
        let acceptCode = patchReq ? [204] : [201];
        return this.callApi(routePart, httpMethod, acceptCode, data);
    }

    saveFile(data) {        
        let routePart = `${data.disclosureId}/uploadfile`;
        let file = data.file;
     
        return this.upload.upload({
            url: `${this.apiPath}/${routePart}`,
            file: file,
            data: {
                "Content-Type": file.type
            }
        }).then((response) => {
            if (response.status === 200) {
                return {
                    data: response.data,
                    error: ''
                };
            } else if (response.status === 406) {
                return {
                    data: null,
                    error: 'Invalid file'
                }
            }
            return {
                data: null,
                error: 'File Upload service error'
            };
        });
    }

    submitDisclosure(disclosureid) {
        let routePart = `${disclosureid}/submit`;
        return this.callApi(routePart, this.http.patch, [204], null);
    }

    amendDisclosure(disclosureid) {
        let routePart = `${disclosureid}/amend`;
        return this.callApi(routePart, this.http.patch, [204], null);
    }

    submitIsuReview(reviewDto) {
        let routePart = `${reviewDto.disclosureId}/submitisuassessment`;
        return this.callApi(routePart, this.http.patch, [204], reviewDto);
    }

    returnToAssessor(reviewDto) {
        let routePart = `${reviewDto.disclosureId}/returntoassessor`;
        return this.callApi(routePart, this.http.patch, [204], reviewDto);
    }

    submitRoAssignment(roAssignDto) {
        let routePart = `${roAssignDto.disclosureId}/submitroassignment`;
        return this.callApi(routePart, this.http.patch, [204], roAssignDto);
    }   

    deactiveDisclosure(deactivationDto) {
        let routePart = `${deactivationDto.disclosureId}/deactivate`;
        return this.callApi(routePart, this.http.patch, [204], deactivationDto);
    }
    
    cancelDisclosure(disclosureid) {
        let routePart = `${disclosureid}/canceldisclosure`;
        return this.callApi(routePart, this.http.patch, [204], null);
    }

    reviewedDisclosure(disclosureid) {
        let routePart = `${disclosureid}/reviewedDisclosure`;
        return this.callApi(routePart, this.http.patch, [204], null);
    }
    //archive disclosure
    archiveDisclosure(disclosureid) {
        let routePart = `${disclosureid}/archiveDisclosure`;
        return this.callApi(routePart, this.http.patch, [204], null);
    }
}

DisclosureService.$inject = ['_', '$http', 'initConfigProvider', 'securityService', 'Upload'];

export default DisclosureService;



// WEBPACK FOOTER //
// ./app/services/disclosure.service.js